import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { Sidebar } from '@/components/sections/Sidebar';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        <meta name="robots" content="max-image-preview:large" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://airhaven.net/" />
        <meta property="og:title" content={siteData.title} />
        <meta property="og:description" content={siteData.description} />
        <meta property="og:image" content="/images/Air-Haven-Logo1.gif" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://airhaven.net/" />
        <meta property="twitter:title" content={siteData.title} />
        <meta property="twitter:description" content={siteData.description} />
        <meta property="twitter:image" content="/images/Air-Haven-Logo1.gif" />
        
        {/* Additional SEO */}
        <link rel="canonical" href="https://airhaven.net/" />
        <meta name="author" content="Air Haven" />
        <meta name="theme-color" content="#1e73be" />
      </Helmet>
      
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        
        <div id="main" className="flex flex-col lg:flex-row max-w-7xl mx-auto px-4 py-8 gap-8 flex-1">
          <main id="content" className="flex-1">
            <Hero />
          </main>
          
          {siteData.sidebar && (
            <Sidebar sidebarData={siteData.sidebar} />
          )}
        </div>

        <Footer footerData={siteData.footer} />
      </div>
    </>
  );
}